<template>
    <div id="mainMessages" class="chat_conversion chat_converse">
        <div v-for="reply in replies" :key="reply.id">
            <div class="chat_msg_item"
                :class="!reply.is_operator ? 'chat_msg_item_user fl-right' : 'chat_msg_item_admin fl-left'"
            
            >
                <span
                    v-html="reply.content"
                ></span>
                <ticket-reply-attachment-open
                    v-if="reply.upload"
                    v-model="reply.upload"
                ></ticket-reply-attachment-open>
            </div>
            <div class="status"
                :class="!reply.is_operator ? 'fl-right' : 'fl-left'"
            >
                {{ $moment(reply.created_at).format('lll')  }}
            </div>
        </div>
    </div>
</template>

<script>

    import TicketReplyAttachmentOpen from './TicketReplyAttachmentOpen';

    export default {
    emits: ['input', 'update:modelValue'],

        name: 'TicketReplies',

        components: {
            TicketReplyAttachmentOpen
        },

        props: {
            modelValue: {
                type: Object,
                required: true,
            }
        },
        
        mounted() {
            this.getReplies();
            setInterval(this.getReplies, 20000)
        },

        computed: {

            ticket: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit('update:modelValue', value);
                    this.$emit('input', value);
                }
            },

            replies: {
                get() {
                    return this.ticket.replies
                },
                set(replies) {
                    this.ticket.replies = replies
                    this.$emit('update:modelValue', this.ticket);
                    this.$emit('input', this.ticket);
                }
            }
        },
        
        methods: {

            push(reply) {
                this.replies.push(reply)
                this.scroll()  
            },

            scroll() {
                setTimeout(() => {
                    const $mainMessages = document.getElementById("mainMessages");
                    $mainMessages.scrollTop = $mainMessages.scrollHeight;
                }, 100);
            },

            getReplies() {
                return window.axios
                    .get(`/api/app/tickets/${this.ticket.id}/replies`)
                    .then(res => {
                        if (
                            !this.replies ||
                            (this.replies.length !== 
                            res.data.ticket.replies.length)
                        ) {
                            this.scroll();
                        }
                        this.ticket = res.data.ticket;
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }

    }
</script>


<style scoped>
    .fl-left {
        float: left;
        margin-left: 15px;
    }

    .fl-right {
        float: right;
        margin-right: 15px;
    }

    .chat_converse {
        position: relative;
        background: #fff;
        height: 350px;
        min-height: 0;
        font-size: 12px;
        line-height: 18px;
        overflow-y: auto;
        width: 100%;
        float: right;
        padding-bottom: 30px;
    }

    .chat_converse .chat_msg_item {
        position: relative;
        margin: 8px 0 8px 0;
        padding: 8px 10px;
        max-width: 60%;
        display: block;
        word-wrap: break-word;
        border-radius: 3px;
        -webkit-animation: zoomIn 0.5s cubic-bezier(0.42, 0, 0.58, 1);
        animation: zoomIn 0.5s cubic-bezier(0.42, 0, 0.58, 1);
        clear: both;
        z-index: 2;
    }

    .status {
        clear: both;
        font-size: 11px;
        opacity: 0.3;
    }

    .chat_converse .chat_msg_item .chat_avatar {
        position: absolute;
        top: 0;
    }

    .chat_converse .chat_msg_item.chat_msg_item_admin .chat_avatar {
        left: -52px;
        background: rgba(0, 0, 0, 0.03);
    }

    .chat_converse .chat_msg_item.chat_msg_item_user .chat_avatar {
        right: -52px;
        background: rgba(0, 0, 0, 0.6);
    }

    .chat_converse .chat_msg_item .chat_avatar,
    .chat_avatar img {
        width: 40px;
        height: 40px;
        text-align: center;
        border-radius: 50%;
    }

    .chat_converse .chat_msg_item.chat_msg_item_admin {
        margin-left: 15px;
        float: left;
        background: rgba(0, 0, 0, 0.03);
        color: #666;
    }

    .chat_converse .chat_msg_item.chat_msg_item_user {
        margin-right: 15px;
        float: right;
        background: #42a5f5;
        color: #eceff1;
    }

    .chat_converse .chat_msg_item.chat_msg_item_admin:before {
        content: "";
        position: absolute;
        top: 15px;
        left: -12px;
        z-index: 998;
        border: 6px solid transparent;
        border-right-color: rgba(255, 255, 255, 0.4);
    }

    /*Chatbox scrollbar*/

    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        border-radius: 0;
    }

    ::-webkit-scrollbar-thumb {
        margin: 2px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.2);
    }

    /*Animation*/

    @-webkit-keyframes zoomIn {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes zoomIn {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }

    @-webkit-keyframes load {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        50% {
            -webkit-transform: scale(1.5);
            transform: scale(1.5);
            opacity: 1;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 0;
        }
    }

    @keyframes load {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        50% {
            -webkit-transform: scale(1.5);
            transform: scale(1.5);
            opacity: 1;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 0;
        }
    }

    /*Color Options*/

    .blue .fab {
        background: #42a5f5;
        color: #fff;
    }

    .blue {
        background: #42a5f5;
        color: #999;
    }

    /* Ripple */

    .ink {
        display: block;
        position: absolute;
        background: rgba(38, 50, 56, 0.4);
        border-radius: 100%;
        -moz-transform: scale(0);
        -ms-transform: scale(0);
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    /*animation effect*/

    .ink.animate {
        -webkit-animation: ripple 0.5s ease-in-out;
        animation: ripple 0.5s ease-in-out;
    }

    @-webkit-keyframes ripple {

        100% {
            opacity: 0;
            -moz-transform: scale(5);
            -ms-transform: scale(5);
            webkit-transform: scale(5);
            -webkit-transform: scale(5);
            transform: scale(5);
        }
    }

    @keyframes ripple {

        100% {
            opacity: 0;
            -moz-transform: scale(5);
            -ms-transform: scale(5);
            webkit-transform: scale(5);
            -webkit-transform: scale(5);
            transform: scale(5);
        }
    }

    ::-webkit-input-placeholder {
        color: #bbb;
    }

    :-ms-input-placeholder {
        color: #bbb;
    }

    ::-moz-placeholder {
        color: #bbb;
    }

    :-moz-placeholder {
        color: #bbb;
    }

</style>
